import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";

export function setReturnOdcLoadType(
  ftlRoutes: Array<FtlRouteViewModel>,
  ftlRouteNumber: string | undefined,
  pdsrId: number,
  myField: string,
  loadType: string
) {
  return ftlRoutes?.map((ftlRoute) => {
    if (ftlRoute.RouteNumber !== ftlRouteNumber) {
      return ftlRoute;
    }

    return {
      ...ftlRoute,
      PdsrsOnThisRoute: ftlRoute.PdsrsOnThisRoute?.map((pdsr) => {
        if (pdsr.PdsrId !== pdsrId) {
          return pdsr;
        }

        return {
          ...pdsr,
          ODCs: pdsr.ODCs?.map((odcItem) => {
            if (odcItem.OdcGsdb !== myField) {
              return odcItem;
            }
            return {
              ...odcItem,
              LoadType: loadType,
            };
          }),
        };
      }),
    };
  });
}
